import { render, staticRenderFns } from "./alltext.vue?vue&type=template&id=5dd658af&scoped=true&"
import script from "./alltext.vue?vue&type=script&lang=js&"
export * from "./alltext.vue?vue&type=script&lang=js&"
import style0 from "./alltext.vue?vue&type=style&index=0&id=5dd658af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd658af",
  null
  
)

export default component.exports